var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandColorGateIo = function SvgBrandColorGateIo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2354E6",
    fillRule: "evenodd",
    d: "M12 17.5a5.5 5.5 0 1 1 0-11V2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10h-4.5a5.5 5.5 0 0 1-5.5 5.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#17E6A1",
    fillRule: "evenodd",
    d: "M12 12h5.5V6.5H12z",
    clipRule: "evenodd"
  })));
};
export { SvgBrandColorGateIo as ReactComponent };